module.exports = __webpack_public_path__ + "static/media/slide2.024e7adc.gif";